import { createFileRoute } from '@tanstack/react-router'

import { PlatformPendingUserGeneratedEndorsementPage } from '../../../../../../components/pages/backoffice/platform/platform-endorsement-page/platform-pending-user-generated-endorsement-page.tsx'
import { InviteToLoginPage } from '../../../../../../components/templates/invite-to-login/invite-to-login-page.tsx'

import { useManagedByOrusOnlyPermissions } from '#/lib/use-managed-by-orus-only-permissions.ts'
import { usePermissions } from '#/lib/use-permissions.ts'

const PendingUserGeneratedEndorsementRoute = () => {
  const { subscriptionId } = Route.useParams()
  const { hasPermission } = usePermissions()
  const { hasManagedByOrusScopedPermission } = useManagedByOrusOnlyPermissions({
    subscriptionId,
    managedByOrusOnlyPermission: 'endorsement.create.managedByOrusOnly',
  })
  if (!hasPermission('endorsement.create') && !hasManagedByOrusScopedPermission) {
    return <InviteToLoginPage />
  }

  return <PlatformPendingUserGeneratedEndorsementPage />
}

export const Route = createFileRoute('/bo/contracts/$subscriptionId/endorsements/$endorsementId/')({
  component: PendingUserGeneratedEndorsementRoute,
})
